import { useState } from "react";
import { useApp } from "../../context/AppContext";
import { signedPost } from "../../api/client";
import { ModalSheet } from "../shared/ModalSheet";

export function EventComposerSheet() {
  const { showAddEvent, setShowAddEvent, session, refreshAll } = useApp();
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<string | null>(null);

  if (!session) return null;

  const submit = async () => {
    setError(null);
    const occursOn = date.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(occursOn)) {
      setError("Use YYYY-MM-DD for the date.");
      return;
    }
    const canonical = `event|${title.trim()}|${occursOn}|${location.trim()}|${linkUrl.trim()}`;
    await signedPost(session, "/family/submissions/event", {
      title: title.trim(),
      occurs_on: occursOn,
      location_text: location.trim() || null,
      link_url: linkUrl.trim() || null,
    }, canonical);
    setStatus("Submitted for admin review.");
    setTitle("");
    setDate("");
    setLocation("");
    setLinkUrl("");
    await refreshAll();
  };

  return (
    <ModalSheet
      open={showAddEvent}
      onClose={() => setShowAddEvent(false)}
      title="Add a family event"
    >
      <p className="muted">Events need admin approval before they appear in the feed.</p>
      <input className="field" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
      <input className="field" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
      <input className="field" placeholder="Location (optional)" value={location} onChange={(e) => setLocation(e.target.value)} />
      <input className="field" placeholder="Link URL (optional)" value={linkUrl} onChange={(e) => setLinkUrl(e.target.value)} />
      {error ? <p className="error-text">{error}</p> : null}
      {status ? <p className="muted">{status}</p> : null}
      <button type="button" className="btn-primary" disabled={!title.trim() || !date.trim()} onClick={() => void submit()}>
        Submit event
      </button>
      <button type="button" className="btn-ghost" onClick={() => setShowAddEvent(false)}>
        Cancel
      </button>
    </ModalSheet>
  );
}

export function AnnouncementComposerSheet() {
  const { showAddAnnouncement, setShowAddAnnouncement, session, refreshAll } = useApp();
  const [category, setCategory] = useState("general");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<string | null>(null);

  if (!session) return null;

  const submit = async () => {
    const canonical = `${category}|${message.trim()}`;
    await signedPost(session, "/announcements", {
      category,
      message: message.trim(),
    }, canonical);
    setMessage("");
    setStatus("Posted to the family feed.");
    await refreshAll();
    setShowAddAnnouncement(false);
  };

  return (
    <ModalSheet
      open={showAddAnnouncement}
      onClose={() => setShowAddAnnouncement(false)}
      title="New announcement"
    >
      <select className="field" value={category} onChange={(e) => setCategory(e.target.value)}>
        <option value="general">General</option>
        <option value="engagement">Engagement</option>
        <option value="baby">Baby</option>
        <option value="celebration">Celebration</option>
      </select>
      <textarea className="field" rows={4} placeholder="Share news with the family" value={message} onChange={(e) => setMessage(e.target.value)} />
      {status ? <p className="muted">{status}</p> : null}
      <button type="button" className="btn-primary" disabled={!message.trim()} onClick={() => void submit()}>
        Post announcement
      </button>
      <button type="button" className="btn-ghost" onClick={() => setShowAddAnnouncement(false)}>
        Cancel
      </button>
    </ModalSheet>
  );
}
